import { getColorHexValue } from 'theme-utilities';

const degToRad = (degrees) => (Math.PI / 180) * degrees;

const getOrbitColors = (canvas) => {
	const colors = {
		orbit: getColorHexValue('primary', 0.1),
		satellite: getColorHexValue('secondary'),
	};

	if (canvas.classList.contains('orbit--highlight')) {
		colors.orbit = getColorHexValue('body', 0.1, true);
		colors.satellite = getColorHexValue('secondary');
	} else if (canvas.classList.contains('orbit--alternative-colors')) {
		colors.orbit = getColorHexValue('primary', 0.2);
		colors.satellite = getColorHexValue('primary');
	}

	return colors;
};

const initCanvasElements = () => {
	document.querySelectorAll('canvas.orbit').forEach((canvas) => {
		if (canvas.classList.contains('orbit--reverse')) {
			canvas.style.transform = 'rotate(180deg)';
		}

		const colors = getOrbitColors(canvas);

		const cv = canvas.getContext('2d');

		const settings = {
			satellite: {
				length: 150,
				scale: 2,
			},
			view: {
				height: 300,
			},
		};

		const orbitDimensions = {
			x: window.innerWidth / 2,
			y: window.innerWidth * settings.satellite.scale + settings.view.height / 3,
			size: window.innerWidth * settings.satellite.scale,
		};

		canvas.width = document.querySelector('html').clientWidth;
		canvas.height = 300;

		const circleLength = orbitDimensions.size * 2 * Math.PI;
		const satDegreeLength = (settings.satellite.length / circleLength) * 360;
		const sineOfAngle = canvas.width / 2 / orbitDimensions.size;
		const angleInRadians = Math.asin(sineOfAngle);
		const angleInDegrees = (angleInRadians * 180) / Math.PI;

		const draw = (progress) => {
			// Background
			cv.fillStyle = 'transparent';
			cv.fillRect(0, 0, canvas.width, canvas.height);

			// Orbit
			cv.beginPath();
			cv.arc(orbitDimensions.x, orbitDimensions.y, orbitDimensions.size, degToRad(0), degToRad(360), true);
			cv.lineWidth = 2;
			cv.strokeStyle = colors.orbit;
			cv.stroke();

			// Satellite
			cv.beginPath();
			cv.arc(
				orbitDimensions.x,
				orbitDimensions.y,
				orbitDimensions.size,
				degToRad(270 - angleInDegrees + progress),
				degToRad(270 - (angleInDegrees + satDegreeLength) + progress),
				true,
			);
			cv.lineWidth = 16;
			cv.lineCap = 'round';
			cv.strokeStyle = colors.satellite;
			cv.stroke();
		};

		let progress = 0;

		const animation = () => {
			cv.clearRect(0, 0, canvas.width, canvas.height);

			if (canvas.width >= 500) {
				progress += canvas.width >= 1200 ? 0.025 : 0.05;
			} else {
				progress += 0.0875;
			}

			if (progress > angleInDegrees * 2 + satDegreeLength) {
				progress = 0;
			}

			draw(progress);
			requestAnimationFrame(animation);
		};

		animation();
	});
};

window.addEventListener('DOMContentLoaded', initCanvasElements);
window.addEventListener('resize', initCanvasElements);
document.addEventListener('colorModeChange', initCanvasElements);
